import { DwhSriCategory } from '@ndvr/market-data-api';

import { useSRICategories } from '@/hooks/market-data-queries';

interface UseSriDataReturn {
    categories?: DwhSriCategory[];
    isFetching: boolean;
    isLoading: boolean;
}

export const useSriData = (): UseSriDataReturn => {
    const {
        data: categories,
        isLoading,
        isFetching,
    } = useSRICategories({ refetchOnMount: false, refetchOnWindowFocus: false });

    return {
        categories,
        isLoading,
        isFetching,
    };
};
